<template>
<div id="catalogo_mt">
  <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
  components: {
    "v-power-catalogo": powerCatalogo
  },
  created() {
    window.getApp.$emit("APP_DRAWER_HIDE");
  },

  data: () => ({
    fab: false,
    parametros: {
      url_actions: "apendices/",
      url_list: "apendices/lista/",
      tabla: 35,
      title: "TIPOS CERTIFICACIÓN",
      columns: ["clave", "nombre", "vigencia", "actions"],
      options: {
        filterable: ["clave", "nombre", "vigencia"],
        sortable: ["clave", "nombre", "vigencia"],

        headings: {
          clave: "Clave",
          nombre: "Nombre",
          vigencia: "Vigencia",
          actions: "Operaciones"
        }
      },
      camposexcel: {
        Clave: "clave",
        Nombre: "nombre",
        Vigencia: "vigencia"
      },
      encabezadoLayout: {
        clave: "clave",
        nombre: "nombre",
        vigencia: "vigencia"
      },
      camposLayout: [{
        clave: "[Clave de la Certificación]",
        nombre: "[Nombre de la Certificación]",
        vigencia: "[Vigencia de la Certificación]",
      }],
      model: {
        id: 0,
        clave: "",
        nombre: "",
        vigencia:""
      },
      form: {
        clave: {
          requiered: true,
          label: "Clave",
          value: "",
          maxlen: 50
        },
        nombre: {
          requiered: true,
          label: "Nombre",
          value: "",
          maxlen: 100
        },
        vigencia: {
          requiered: true,
          label: "Vigencia",
          value: "",
          maxlen: 2
        }
      },
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "Utilerías",
          disabled: true,
          to: ""
        },
        {
          text: "Apendices",
          disabled: true,
          to: ""
        }
      ]
    }
  })
};
</script>
<style scoped>
.v-card--material {
  min-height: 750px !important;
}
</style>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
